import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React from 'react';

import { useI18n } from '../../../../../../../../application/language/useI18n';
import { IUnitCardModel } from '../../../../../../service/unit/interface/IUnitCardModel';
import { OverflownContent } from '../../../LearningUnitPreviewPage/shared/OverflownContent';

type Props = {
  unit?: IUnitCardModel;
  status: 'important' | 'unimportant';
};

export const UnitCardHeader = observer(({ unit, status }: Props) => {
  const i18n = useI18n();
  const classes = useStyles();

  const statusMap = {
    important: {
      title: i18n.translate('phrases.mandatory'),
      borderColor: '#90CAF9',
      color: '#90CAF9',
      icon: <InfoOutlinedIcon sx={{ color: '#90CAF9', width: '18px', height: '18px' }} />,
    },
    unimportant: {
      title: i18n.translate('phrases.optional'),
      borderColor: '#FFFFFF50',
      color: '#FFF',
      icon: undefined,
    },
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', gap: 1 }}>
      <OverflownContent contentClasses={classes.groupTitle}>{unit?.settings.titleHeading}</OverflownContent>
      <Box
        sx={{
          borderColor: statusMap[status].borderColor,
          color: statusMap[status].color,
          borderWidth: '1px',
          borderStyle: 'solid',
          height: 'fit-content',
          borderRadius: '16px',
          padding: '4px 8px',
          display: 'flex',
          gap: '4px',
        }}
      >
        <Box sx={{ fontSize: '4px' }}>{statusMap[status].icon}</Box>
        <Box sx={{ fontSize: '12px' }}>{statusMap[status].title}</Box>
      </Box>
    </Box>
  );
});

const useStyles = makeStyles(() => ({
  groupTitle: {
    lineHeight: '28px',
    fontWeight: '600',
    fontSize: '20px',
    cursor: 'pointer',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    whiteSpace: 'normal',
    lineClamp: 2,
  },
}));
